<div class="container-fluid mt-3">

  <!-- FILTER SECTION -->
  <div class="mb-3 p-3">

    <div class="row mb-3">
      <div class="col-lg-3 col-md-3 mt-2 mb-2">
        <div class="form-floating">
          <input type="date" class="form-control" [(ngModel)]="fromDate" (change)="onDate()" [max]="toDate || todayMax">
          <label>From Date</label>
        </div>
      </div>

      <div class="col-lg-3 col-md-3 mt-2 mb-2">
        <div class="form-floating">
          <input type="date" class="form-control" [(ngModel)]="toDate" (change)="onDate()" [max]="todayMax">
          <label>To Date</label>
        </div>
      </div>

       <div class="col-lg-3 col-md-4 mt-2 mb-2">

        <input
          type="file"
          id="bankStatementFile"
          class="d-none"
          accept=".xlsx,.xls"
          (change)="onBankStatementFileSelected($event)">

        <button
          type="button"
          class="btn btn-primary w-100"
          style="height: 58px;"
          (click)="openBankFilePicker()">

          <i class="fa fa-upload me-2"></i>

          Upload Bank Statement

        </button>

      </div>
    </div>
    
    <div class="row g-3">

      <!-- Floating Search -->
      <div class="col-md-6 col-lg-4">
        <div class="form-floating">
          <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchText"
            (input)="applyLocalFilter()">
          <label>Search by Name / Phone / Invoice</label>
        </div>
      </div>

      <!-- Floating Status -->
      <div class="col-md-3 col-lg-3">
        <div class="form-floating">
          <select class="form-select" [(ngModel)]="selectedStatus" (change)="applyLocalFilter()">
            <option value="">All</option>
            <option value="INITIATED">INITIATED</option>
            <option value="SUCCESS">SUCCESS</option>
            <option value="FAILED">FAILED</option>
            <option value="PENDING">PENDING</option>
          </select>
          <label>Transaction Status</label>
        </div>
      </div>

  <div class="col-md-3 col-lg-3 text-end">
    <div class="form-floating">
          <input type="text" class="form-control text-bold" placeholder="Search" value="₹ {{ totalReceivedAmount | number:'1.2-2' }}" readonly>
          <label>Total Received Amount</label>
        </div>
  </div>

      <!-- Reset -->
      <div class="col-md-2 d-flex align-items-end">
        <button class="btn btn-danger w-100" (click)="clearFilter()">
          <i class="fa fa-refresh" aria-hidden="true"></i>
          Reset
        </button>
      </div>

    </div>
  </div>


  <!-- TABLE SECTION -->
  <div class="container-fluid">
    <div class="table-style table-responsive table-bordered">
      <table class="table table-head-fixed text-nowrap text-center">
        <thead>
          <tr class="sticky-top">
            <th>#</th>
            <th>Invoice No</th>
            <th>Customer Name</th>
            <th>Phone</th>
            <th>Total Amount</th>
            <th>Payment Method</th>
            <th>Transaction Ref</th>
            <th>Status</th>
            <th>Date</th>
          </tr>
        </thead>

        <tbody>

          <tr *ngIf="filteredList.length === 0">
            <td colspan="9" class="text-danger text-center">
              No Data Found
            </td>
          </tr>

          <tr *ngFor="let bill of filteredList; let i = index">

            <td>{{ i + 1 }}</td>
            <td>{{ bill?.invoiceNumber || '-' }}</td>
            <td>{{ bill?.customerName || '-' }}</td>
            <td>{{ bill?.phoneNumber || '-' }}</td>
            <td>₹ {{ bill?.totalAmount || '-' }}</td>

            <td>
              {{ bill?.transactionDetails?.paymentMethod || '-' }}
            </td>

            <td>
              {{ bill?.transactionDetails?.transactionRefId || '-' }}
            </td>

            <td>
              <span class="badge" [ngClass]="{
                  'bg-success': bill?.transactionDetails?.paymentStatus === 'SUCCESS',
                  'bg-warning text-dark': bill?.transactionDetails?.paymentStatus === 'PENDING',
                  'bg-danger': bill?.transactionDetails?.paymentStatus === 'FAILED',
                  'bg-secondary': bill?.transactionDetails?.paymentStatus === 'INITIATED'
                }">
                {{ bill?.transactionDetails?.paymentStatus || '-' }}
              </span>
            </td>

            <td>
              {{ (bill?.transactionDetails?.createdAt | date:'dd-MM-yyyy') || '-' }}
            </td>

          </tr>

        </tbody>
      </table>

    </div>
  </div>

</div>

<!-- ===================================================== -->
<!-- BANK STATEMENT VERIFICATION MODAL -->
<!-- ===================================================== -->

<div
  #bankStatementModal
  class="modal fade"
  id="bankStatementModal"
  tabindex="-1"
  aria-labelledby="bankStatementModalLabel"
  aria-hidden="true">

  <div
    class="modal-dialog modal-fullscreen-lg-down modal-xl modal-dialog-scrollable">

    <div class="modal-content">


      <!-- HEADER -->
      <div class="modal-header bg-primary text-white">

        <h5
          class="modal-title"
          id="bankStatementModalLabel">

          <i class="fa fa-university me-2"></i>

          Bank Statement Verification

          <span
            *ngIf="bankFileName"
            class="small ms-2">

            - {{ bankFileName }}

          </span>

        </h5>


        <button
          type="button"
          class="btn-close btn-close-white"
          data-bs-dismiss="modal"
          aria-label="Close">

        </button>

      </div>


      <!-- BODY -->
      <div class="modal-body">


        <!-- SEARCH + STATUS + DOWNLOAD -->
        <div class="row g-3 mb-3">


          <!-- SEARCH -->
          <div class="col-lg-5 col-md-6">

            <div class="form-floating">

              <input
                type="text"
                class="form-control"
                placeholder="Search"
                [(ngModel)]="bankSearchText"
                (input)="applyBankStatementFilter()">

              <label>
                Search Remarks / Invoice / Customer / Ref
              </label>

            </div>

          </div>


          <!-- STATUS -->
          <div class="col-lg-3 col-md-4">

            <div class="form-floating">

              <select
                class="form-select"
                [(ngModel)]="bankVerificationStatus"
                (change)="applyBankStatementFilter()">

                <option value="">
                  All
                </option>

                <option value="VERIFIED">
                  VERIFIED
                </option>

                <option value="NOT MATCHED">
                  NOT MATCHED
                </option>

              </select>

              <label>
                Verification Status
              </label>

            </div>

          </div>


          <!-- DOWNLOAD -->
          <div class="col-lg-4 col-md-6 d-flex align-items-center">

            <button
              type="button"
              class="btn btn-success w-100"
              style="height: 58px;"
              (click)="downloadBankVerificationExcel()">

              <i class="fa fa-file-excel-o me-2"></i>

              Download Verification Excel

            </button>

          </div>

        </div>


        <!-- SUMMARY -->
        <div
          class="row g-3 mb-3">


          <!-- VERIFIED -->
          <div class="col-lg-4 col-md-6">

            <div
              class="card border-success shadow-sm">

              <div class="card-body">

                <div class="d-flex justify-content-between">

                  <div>

                    <div class="text-success fw-bold">
                      Verified Transactions
                    </div>

                    <div class="fs-4 fw-bold">
                      {{ verifiedCount }}
                    </div>

                  </div>

                  <div
                    class="text-success fs-2">

                    <i class="fa fa-check-circle"></i>

                  </div>

                </div>

              </div>

            </div>

          </div>


          <!-- NOT MATCHED -->
          <div class="col-lg-4 col-md-6">

            <div
              class="card border-danger shadow-sm">

              <div class="card-body">

                <div class="d-flex justify-content-between">

                  <div>

                    <div class="text-danger fw-bold">
                      Not Matched
                    </div>

                    <div class="fs-4 fw-bold">
                      {{ notMatchedCount }}
                    </div>

                  </div>

                  <div
                    class="text-danger fs-2">

                    <i class="fa fa-times-circle"></i>

                  </div>

                </div>

              </div>

            </div>

          </div>


          <!-- VERIFIED AMOUNT -->
          <div class="col-lg-4 col-md-6">

            <div
              class="card border-primary shadow-sm">

              <div class="card-body">

                <div class="d-flex justify-content-between">

                  <div>

                    <div class="text-primary fw-bold">
                      Verified Amount
                    </div>

                    <div class="fs-4 fw-bold">

                      ₹
                      {{ verifiedAmount | number:'1.2-2' }}

                    </div>

                  </div>

                  <div
                    class="text-primary fs-2">

                    <i class="fa fa-money"></i>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>


        <!-- BANK TABLE -->
        <div
          class="table-responsive"
          style="max-height: 60vh; overflow: auto;">

          <table
            class="table table-bordered table-hover table-striped text-nowrap text-center align-middle">


            <thead
              class="table-dark sticky-top">

              <tr>

                <th>
                  #
                </th>

                <th>
                  Date
                </th>

                <th>
                  Remarks
                </th>


                <th>
                  Credit
                </th>

                <th>
                  Transaction Ref
                </th>

                <th>
                  Transaction Amount
                </th>

                <th>
                  Invoice No
                </th>

                <th>
                  Customer
                </th>

                <th>
                  Phone
                </th>

                <th>
                  Status
                </th>

              </tr>

            </thead>


            <tbody>


              <!-- NO DATA -->
              <tr
                *ngIf="
                  filteredBankStatementList.length === 0
                ">

                <td
                  colspan="12"
                  class="text-danger text-center py-4">

                  <i
                    class="fa fa-info-circle me-2">
                  </i>

                  No bank statement data found.

                </td>

              </tr>


              <!-- DATA -->
              <tr
                *ngFor="
                  let row of filteredBankStatementList;
                  let i = index
                ">


                <td>
                  {{ i + 1 }}
                </td>


                <td>
                  {{ row.date || '-' }}
                </td>


                <td
                  class="text-start"
                  style="min-width: 400px; white-space: normal;">

                  {{ row.remarks || '-' }}

                </td>


                <!-- CREDIT -->
                <td>

                  <span
                    *ngIf="row.credit > 0"
                    class="text-success fw-bold">

                    ₹
                    {{ row.credit | number:'1.2-2' }}

                  </span>

                  <span
                    *ngIf="row.credit === 0">

                    -

                  </span>

                </td>


                <!-- TRANSACTION REF -->
                <td>

                  <span
                    *ngIf="row.transactionRefId"
                    class="fw-bold">

                    {{ row.transactionRefId }}

                  </span>

                  <span
                    *ngIf="!row.transactionRefId">

                    -

                  </span>

                </td>


                <!-- TRANSACTION AMOUNT -->
                <td>

                  <span
                    *ngIf="row.transactionAmount > 0">

                    ₹
                    {{ row.transactionAmount | number:'1.2-2' }}

                  </span>

                  <span
                    *ngIf="row.transactionAmount === 0">

                    -

                  </span>

                </td>


                <!-- INVOICE -->
                <td>

                  {{ row.matchedInvoiceNumber || '-' }}

                </td>


                <!-- CUSTOMER -->
                <td>

                  {{ row.matchedCustomerName || '-' }}

                </td>


                <!-- PHONE -->
                <td>

                  {{ row.matchedPhoneNumber || '-' }}

                </td>


                <!-- STATUS -->
                <td>

                  <span
                    class="badge px-3 py-2"
                    [ngClass]="{

                      'bg-success':
                        row.verificationStatus === 'VERIFIED',

                      'bg-danger':
                        row.verificationStatus === 'NOT MATCHED'

                    }">

                    <i
                      class="fa me-1"
                      [ngClass]="{

                        'fa-check':
                          row.verificationStatus === 'VERIFIED',

                        'fa-times':
                          row.verificationStatus === 'NOT MATCHED'

                      }">

                    </i>

                    {{ row.verificationStatus }}

                  </span>

                </td>

              </tr>

            </tbody>

          </table>

        </div>

      </div>


      <!-- FOOTER -->
      <div class="modal-footer">

        <button
          type="button"
          class="btn btn-secondary"
          data-bs-dismiss="modal">

          <i class="fa fa-times me-1"></i>

          Close

        </button>

        <button
          type="button"
          class="btn btn-success"
          *ngIf="filteredBankStatementList.length > 0"
          (click)="downloadBankVerificationExcel()">

          <i class="fa fa-download me-1"></i>

          Download Excel

        </button>

      </div>


    </div>

  </div>

</div>